var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.0625L1.60794 5.9375L7.80149 8.0625L10.4814 10.1875L9.52853 6.875V0L14.5906 0V6.875L13.5782 10.25L16.1985 8.1875L22.4516 6.125L24 11.1875L17.8064 13.3125L14.4715 13.375L17.0918 15.3125L20.9032 20.875L16.794 24L12.9826 18.5L11.9107 15.1875L10.8983 18.375L7.02729 23.9375L2.91811 20.8125L6.78908 15.25L9.46898 13.25L6.2531 13.125L0 11.0625Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoStar);
export default __webpack_public_path__ + "static/media/ico_star.3288538e3464d44f2c3a69b2e5db2cf5.svg";
export { ForwardRef as ReactComponent };